import { render, staticRenderFns } from "./MsgElementPatient.vue?vue&type=template&id=210a289a&scoped=true"
import script from "./MsgElementPatient.vue?vue&type=script&lang=js"
export * from "./MsgElementPatient.vue?vue&type=script&lang=js"
import style0 from "./MsgElementPatient.vue?vue&type=style&index=0&id=210a289a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a289a",
  null
  
)

export default component.exports